<template>
  <div class="panoramic">
    <div class="panoramic-box">
      <div class="panoramic-content">
        <div class="panoramic-content-left">
          <div class="panoramic-content-one">全方位立体化展示 \ 多视角场景选择</div>
          <div class="panoramic-content-two">全景航拍服务</div>
          <div
            class="panoramic-content-four"
            style=" margin-top: 30px;"
          >房源内部情况摄像录入，三维展示，支持移动端、网页端看房，</div>
          <div class="panoramic-content-four">对房屋进行全景拍摄，为后期风险审核提供技术保障</div>
        </div>
        <div class="panoramic-content-right">
          <img src="../assets/img/quanjing_001.png" />
        </div>
      </div>
    </div>
    <div class="panoramic-content-box">
      <div class="panoramic-one">
        <div class="panoramic-one-left" id="wrapper-text">
          <div class="panoramic-text-one">全方位立体化展现</div>
          <div class="panoramic-text-two">All-round three-dimensional display</div>
          <div class="panoramic-text-three" style="margin-top:30px">通过楼盘内外空间及具体房间功能进行全方位的</div>
          <div class="panoramic-text-three">展示。</div>
        </div>
        <div class="panoramic-one-right" id="wrapper-img">
          <img src="../assets/img/quanjing_01.png" />
        </div>
      </div>
      <div class="panoramic-two">
        <div class="panoramic-one-left" id="wrapper-text1">
          <div class="panoramic-text-one">多视角场景选择</div>
          <div class="panoramic-text-two">Multi-view scene selection</div>
          <div class="panoramic-text-three" style="margin-top:30px">提供房间内部不同场景自定义选择，提高数据自</div>
          <div class="panoramic-text-three">身的立体感和真实感。</div>
        </div>
        <div class="panoramic-one-right" id="wrapper-img1">
          <img src="../assets/img/quanjing_02.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var x = document.getElementById('wrapper-img');
    x.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight panoramic-one-right'
    );
    var y = document.getElementById('wrapper-text');
    y.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft panoramic-one-left'
    );
    var x1 = document.getElementById('wrapper-img1');
    x1.setAttribute(
      'class',
      ' animate__animated animate__fadeInRight panoramic-one-right'
    );
    var y1 = document.getElementById('wrapper-text1');
    y1.setAttribute(
      'class',
      ' animate__animated animate__fadeInLeft panoramic-one-left'
    );
  }
};
</script>
<style>
.panoramic {
  width: 100%;
}
.panoramic-box {
  display: flex;
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.panoramic-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.panoramic-content-left {
  width: 50%;
  margin-top: 70px;
  margin-left: 30px;
}
.panoramic-content-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #ffffff;
}
.panoramic-content-two {
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
  margin-top: 34px;
}
.panoramic-content-three {
  margin-top: 20px;
  font-family: '微软雅黑 Bold', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
}
.panoramic-content-four {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.panoramic-content-right {
  width: 50%;
}
.panoramic-content-right img {
  width: 100%;
}
.panoramic-content-box {
  width: 1500px;
  margin: auto;
  overflow: hidden;
}
.panoramic-one,
.panoramic-two,
.panoramic-three {
  display: flex;
  height: 500px;
  padding: 0 80px;
  overflow: hidden;
}
.panoramic-text-one {
  margin-top: 96px;
  font-family: 微软雅黑;
  font-weight: 400;
  font-style: normal;
  font-size: 48px;
  color: rgb(73, 83, 98);
}
.panoramic-text-two {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 30px;
  color: #999999;
}
.panoramic-text-three {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  color: #495362;
  line-height: 50px;
}
.panoramic-one-left, .panoramic-one-right {
  width: 50%;
}
.panoramic-one-right img {
  margin-top: 50px;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .panoramic-content,
  .panoramic-content-box {
    width: 1200px !important;
  }
  .panoramic-content-two {
    font-size: 48px !important;
  }
  .panoramic-text-one {
    font-size: 36px !important;
  }
  .panoramic-text-two {
    font-size: 28px !important;
  }
  .panoramic-text-three {
    font-size: 24px !important;
  }
  .panoramic-one-right img {
    width: 472px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/panoramic-aerial-photography.vue